import { Tv, Radio, Zap, Cpu, Tv2, BarChart3, LucideIcon } from "lucide-react";

export type PlatformId = "cms" | "analytics" | "live";

export interface PlatformConfig {
  id: PlatformId;
  label: string;
  description: string;
  icon: LucideIcon;
  serviceName: string;
}

export const PLATFORMS: PlatformConfig[] = [
  { id: "cms", label: "OTT CMS", description: "Content Management System", icon: Tv, serviceName: "cms" },
  { id: "analytics", label: "Analytics", description: "Data & Insights", icon: BarChart3, serviceName: "analytics" },
  { id: "live", label: "Live", description: "Live Streaming", icon: Radio, serviceName: "live" },
] as const;

export const PLATFORM_SERVICE_MAP: Record<PlatformId, string> = PLATFORMS.reduce(
  (acc, platform) => {
    acc[platform.id] = platform.serviceName;
    return acc;
  },
  {} as Record<PlatformId, string>
);

export const DEFAULT_PLATFORMS = PLATFORMS.reduce(
  (acc, platform) => {
    acc[platform.id] = platform.id === "cms";
    return acc;
  },
  {} as Record<PlatformId, boolean>
);

